var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRolesFullAccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 83,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 42.923a39.456 39.456 0 1078.913 0 39.456 39.456 0 00-78.913 0z",
    fill: "#E1F1CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.99 42.23a26.945 26.945 0 1053.89 0 26.945 26.945 0 00-53.89 0z",
    fill: "#C4E299"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.99 42.23a26.945 26.945 0 1053.89 0 26.945 26.945 0 00-53.89 0z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.818 15.464c.566-5.498 1.387-8.84 2.368-8.86 2.137-.046 4.209 15.868 4.625 35.544.416 19.676-.98 35.663-3.118 35.708-.976.02-1.937-3.284-2.734-8.753",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.657 21.1c4.287-3.489 7.232-5.271 7.936-4.595 1.544 1.48-8.245 14.196-21.863 28.408-13.618 14.213-25.911 24.52-27.454 23.04-.704-.675.952-3.692 4.257-8.123",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.17 45.344c-5.499-.566-8.84-1.387-8.861-2.368-.046-2.135 15.864-4.207 35.544-4.62 19.68-.413 35.663.98 35.708 3.117.02.976-3.284 1.938-8.752 2.735",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.807 25.505c-3.489-4.288-5.272-7.232-4.596-7.937 1.48-1.543 14.197 8.245 28.408 21.863 14.212 13.619 24.52 25.91 23.04 27.45-.675.704-3.691-.952-8.123-4.256",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.292 16.566a3.452 3.452 0 106.905 0 3.452 3.452 0 00-6.905 0z",
    fill: "#C4E299"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.292 16.566a3.452 3.452 0 106.905 0 3.452 3.452 0 00-6.905 0z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.825 17.634a3.452 3.452 0 106.904 0 3.452 3.452 0 00-6.904 0z",
    fill: "#C4E299"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.825 17.634a3.452 3.452 0 106.904 0 3.452 3.452 0 00-6.904 0z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.263 6.602a5.918 5.918 0 1011.836 0 5.918 5.918 0 00-11.836 0z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.263 6.602a5.918 5.918 0 1011.836 0 5.918 5.918 0 00-11.836 0z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4 66.947a6.412 6.412 0 1012.823 0 6.412 6.412 0 00-12.824 0z",
    fill: "#C4E299"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4 66.947a6.412 6.412 0 1012.823 0 6.412 6.412 0 00-12.824 0z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.743 77.854a3.946 3.946 0 107.892 0 3.946 3.946 0 00-7.892 0z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.743 77.854a3.946 3.946 0 107.892 0 3.946 3.946 0 00-7.892 0z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1.099 42.405a4.932 4.932 0 109.864 0 4.932 4.932 0 00-9.864 0z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1.099 42.405a4.932 4.932 0 109.864 0 4.932 4.932 0 00-9.864 0z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M72.122 41.474a4.439 4.439 0 108.878 0 4.439 4.439 0 00-8.878 0z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M72.122 41.474a4.439 4.439 0 108.878 0 4.439 4.439 0 00-8.878 0z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.425 68.014a5.919 5.919 0 1011.838 0 5.919 5.919 0 00-11.838 0z",
    fill: "#C4E299"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.425 68.014a5.919 5.919 0 1011.838 0 5.919 5.919 0 00-11.838 0z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.31 55.094a1.284 1.284 0 001.312-.027c2.776-1.725 13.496-8.987 13.304-18.071l-.181-8.557a1.283 1.283 0 00-.874-1.183c-5.012-1.687-9.361-3.104-12.995-5.963a.986.986 0 00-1.251.027c-3.509 3.01-7.793 4.61-12.725 6.51a1.283 1.283 0 00-.824 1.222l.182 8.556c.187 9.078 11.207 15.88 14.051 17.486z",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.31 55.094a1.284 1.284 0 001.312-.027c2.776-1.725 13.496-8.987 13.304-18.071l-.181-8.557a1.283 1.283 0 00-.874-1.183c-5.012-1.687-9.361-3.104-12.995-5.963a.986.986 0 00-1.251.027c-3.509 3.01-7.793 4.61-12.725 6.51a1.283 1.283 0 00-.824 1.222l.182 8.556c.187 9.078 11.207 15.88 14.051 17.486z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M44.31 55.094a1.284 1.284 0 001.312-.027c2.776-1.725 13.496-8.987 13.304-18.071l-.181-8.557a1.283 1.283 0 00-.874-1.183c-5.012-1.687-9.361-3.104-12.995-5.963a.986.986 0 00-1.251.027c-3.509 3.01-7.793 4.61-12.725 6.51a1.283 1.283 0 00-.824 1.222l.182 8.556c.187 9.078 11.207 15.88 14.051 17.486z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9 52.011c-3.19-1.933-11.54-7.641-11.688-14.474l-.157-7.375c4.063-1.565 7.917-3.112 11.264-5.615 3.453 2.36 7.366 3.741 11.491 5.13l.157 7.375c.144 6.836-7.964 12.892-11.066 14.96z",
    fill: "#C4E299",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M42.446 43.296a1.85 1.85 0 01-1.32-.515l-3.782-3.626a1.853 1.853 0 112.564-2.674l2.446 2.344 7.381-7.7a1.853 1.853 0 112.674 2.565l-8.663 9.036a1.85 1.85 0 01-1.3.57z",
    fill: "#fff",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgRolesFullAccess;